document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.specs-accordion-header').forEach(header => {
    header.addEventListener('click', function() {
      const panel = document.querySelector(`#${header.dataset.target}`);
      const toggle = header.querySelector('.specs-toggle');

      if (header.classList.contains('specs-active')) {
        header.classList.remove('specs-active');
        panel.classList.remove('open');
        toggle.classList.remove('specs-active');
      } else {
        // Close all other panels
        document.querySelectorAll('.specs-accordion-header').forEach(otherHeader => {
          otherHeader.classList.remove('specs-active');
          const otherPanel = document.querySelector(`#${otherHeader.dataset.target}`);
          otherPanel.classList.remove('open');
          otherHeader.querySelector('.specs-toggle').classList.remove('specs-active');
        });

        // Open the clicked panel
        header.classList.add('specs-active');
        panel.classList.add('open');
        toggle.classList.add('specs-active');
      }
    });
  });
});




document.querySelectorAll('[data-before-after]').forEach(wrapper => {
  const slider = wrapper.querySelector('.nj-slider');
  const before = wrapper.querySelector('.nj-before-layer');
  let dragging = false;

  // initial state
  before.style.clipPath = 'inset(0 50% 0 0)';
  slider.style.left = '50%';

  const move = x => {
    const rect = wrapper.getBoundingClientRect();
    let pos = ((x - rect.left) / rect.width) * 100;
    pos = Math.max(0, Math.min(100, pos));

    slider.style.left = pos + '%';
    before.style.clipPath = `inset(0 ${100 - pos}% 0 0)`;
  };

  slider.addEventListener('mousedown', () => dragging = true);
  window.addEventListener('mouseup', () => dragging = false);
  window.addEventListener('mousemove', e => dragging && move(e.clientX));

  slider.addEventListener('touchstart', () => dragging = true);
  window.addEventListener('touchend', () => dragging = false);
  window.addEventListener('touchmove', e => dragging && move(e.touches[0].clientX));
});




async function applySellingPlan({ variantId, sellingPlanId, btn = null }) {
  if (!variantId || !sellingPlanId) return;

  if (btn) btn.classList.add("loading");

  const cart = await fetch("/cart.js").then(res => res.json());

  const matchingItems = cart.items
    .map((item, index) => ({ ...item, line: index + 1 }))
    .filter(item => item.variant_id === variantId);

  if (!matchingItems.length) {
    if (btn) btn.classList.remove("loading");
    return;
  }

  // 🔥 Parallelize all change requests
  await Promise.all(
    matchingItems.map(item =>
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          line: item.line,
          quantity: item.quantity,
          selling_plan: sellingPlanId
        })
      })
    )
  );

  const cartDrawerSlide = document.querySelector("#cart-drawer");
  if (cartDrawerSlide && cartDrawerSlide._onCartRefresh) {
    await cartDrawerSlide._onCartRefresh();
    cartDrawerSlide.show();
  }

  if (btn) btn.style.display = "none";
}

document.addEventListener("click", function (e) {
  const btn = e.target.closest(".subscribe-btn");
  if (!btn) return;

  applySellingPlan({
    variantId: Number(btn.dataset.variantId),
    sellingPlanId: Number(btn.dataset.sellingPlanId),
    btn
  });
});

document.addEventListener("change", function (e) {
  const select = e.target.closest(".subscription-plan-select");
  if (!select || !select.value) return;

  applySellingPlan({
    variantId: Number(select.dataset.variantId),
    sellingPlanId: Number(select.value)
  });
});
